module.exports = __webpack_public_path__ + "static/media/junor.62895b01.jpg";